import { dew as _isImplementedDew } from "./is-implemented";
import { dew as _shimDew } from "./shim";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  exports = _isImplementedDew()() ? Object.keys : _shimDew();
  return exports;
}